import { getSdpSessionId } from '../../../../webrtc/src/sdpUtils/extractors'

/**
 * Checks whether two SDPs have the same session ID.
 * @method hasSameSessionId
 * @param  {string}  sdp    A valid SDP string.
 * @param  {string}  newSdp A valid SDP string.
 * @return {boolean} Whether the two SDPs have the same session ID.
 */
export function hasSameSessionId (sdp, newSdp) {
  const firstSdpSessionId = getSdpSessionId(sdp)
  const secondSdpSessionId = getSdpSessionId(newSdp)

  if (firstSdpSessionId && secondSdpSessionId) {
    return firstSdpSessionId === secondSdpSessionId
  }
}
